import {NgModule} from '@angular/core';
import {SharedProviderModule} from '../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldService} from './form-field.service';
import {DynamicFormComponent} from './dynamic-form/dynamic-form.component';
import {FormFieldComponent} from './form-field/form-field.component';

@NgModule({
  imports: [
    SharedProviderModule,
    ReactiveFormsModule
  ],
  declarations: [DynamicFormComponent,
    FormFieldComponent],
  exports: [
    DynamicFormComponent
  ],
  providers: [FormFieldService]
})
export class FormDataModule {
}
